import { ChakraButton } from "@airhelp/react-ui-components";
import { trackEvents } from "utils/trackingUtils";
import type { NavButtonProps } from "./HeaderNav.d";

export const NavButton = ({ href, title, trackingEvents, dataTestId }: NavButtonProps) => (
  <ChakraButton
    variant="secondary"
    as="a"
    href={href}
    title={title}
    ml={{ lg: 1, xl: 8 }}
    px={{ lg: 3, xl: 6 }}
    width={{ base: "full", lg: "initial" }}
    order={{ base: "2", md: "1" }}
    onClick={() => trackEvents(trackingEvents)}
    data-testid={dataTestId}
    lineHeight="short"
  >
    {title}
  </ChakraButton>
);
